import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons";

import { ImageLetters } from "..";
import { ConditionIcon } from "../../../../components";
import { QUESTION_RESULT_STATUS } from "../../../../util/common";

import "./index.scss";

class WorkingItems extends Component {
  render() {
    let { workingItems, t, lettersMap } = this.props;

    if (workingItems.length < 1) return null;

    const withRemarks = [],
      withoutRemarks = [];

    workingItems.forEach(item => {
      if (item.question_result_status === QUESTION_RESULT_STATUS.OK_WITH_REMARKS) withRemarks.push(item);
      else withoutRemarks.push(item);
    });

    return (
      <Grid className="report-v2-working-items-checks-container component-container">
        <Grid.Row width={16} className="working-items-checks-heading">
          <FontAwesomeIcon icon={faCheckCircle} className="working-items-checks-heading-icon" />
          <h4 className="working-items-checks-heading-title">{t("cc_checked_working_properly").message || "Checked items working properly"}</h4>
        </Grid.Row>

        {withRemarks.length > 0 && (
          <Grid className="working-items-checks-with-remarks">
            {withRemarks.map(result => (
              <Grid.Row key={result.id} className="working-items-checks-row">
                <Grid.Column width={6} className="working-items-checks-row-column">
                  <ConditionIcon status={0} />
                  <ImageLetters images={result.images} lettersMap={lettersMap} />
                  <span className="working-items-checks-title">{result.title}</span>
                </Grid.Column>
                <Grid.Column width={10} className="working-items-checks-remarks">
                  {result.description && <span>{result.description}</span>}
                </Grid.Column>
              </Grid.Row>
            ))}
          </Grid>
        )}

        {withoutRemarks.length > 0 && (
          <Grid className="working-items-checks-groups">
            {withoutRemarks.map(result => (
              <Grid.Row key={result.id} className="working-items-checks-row">
                <Grid.Column width={7} className="working-items-checks-row-column">
                  <ConditionIcon status={0} />
                  <ImageLetters images={result.images} lettersMap={lettersMap} />
                  <span className="working-items-checks-title">{result.title}</span>
                </Grid.Column>
              </Grid.Row>
            ))}
          </Grid>
        )}
      </Grid>
    );
  }
}

const TranslatedWorkingItems = withTranslation()(WorkingItems);

TranslatedWorkingItems.filterWorkingsItems = results => results.filter(r => !r.mechanic_fixed && r.question_result_status <= QUESTION_RESULT_STATUS.OK_WITH_REMARKS);

export default TranslatedWorkingItems;
